//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isProductType } from '@motionelements/core/src/services/catalog.service.js';

export default {
  name: 'LandingDlpDynamicElements',
  components: {
    ProductCard: () => import('@motionelements/core/src/components/product-card/ProductCard.vue'),
    ProductCardAudioBackground: () => import('@motionelements/core/src/components/product-card/sections/ProductCardBackgroundAudio.vue'),
    ProductCardAudio: () => import('@motionelements/core/src/components/product-card/ProductCardAudio.vue'),
    ProductIcon: () => import('@motionelements/core/src/components/product/ProductIcon.vue'),
    SectionHeader: () => import('@/components/landing/SectionHeader.vue'),
    PageLoader: () => import('@motionelements/core/src/components/ui/PageLoader.vue'),
  },
  props: {
    mediaType: { type: String, required: true },
    elements: { type: Array, required: true },
    viewAllUrl: { type: String, default: '' },
    loading: { type: Boolean, default: false },
  },
  computed: {
    dynamicElementsAudio() {
      return this.elements.filter(x => isProductType('audio', x.mediaType));
    },
    dynamicElementsNotAudio() {
      return this.elements.filter(x => !isProductType('audio', x.mediaType));
    },
  },
};
